var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.609,
    height: 17.518,
    viewBox: "0 0 18.609 17.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(4373.044 61.469)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M-4352.28-52a2.179,2.179,0,0,1-.419-.043,2.191,2.191,0,0,0-2.427.851q-2.7,3.129-5.351,6.292a2.182,2.182,0,0,1-2.2.892,2.356,2.356,0,0,1-1.893-1.777,1.991,1.991,0,0,1,.86-2.227q3.345-2.55,6.69-5.1a2.4,2.4,0,0,0,.941-1.343,1.606,1.606,0,0,0,.029-.712,3.131,3.131,0,0,1,.947-3.091c1.082-1.052,2.232-2.034,3.354-3.044a.466.466,0,0,1,.709-.012c.2.2.16.485-.108.729q-1.537,1.393-3.084,2.775a2.753,2.753,0,0,0-.921,1.5,1.479,1.479,0,0,0-.034.638,3.1,3.1,0,0,1-1.406,3.422q-3.286,2.5-6.569,5.005a1.09,1.09,0,0,0-.422,1.463,1.355,1.355,0,0,0,2.362.325q2.687-3.211,5.422-6.381a3.119,3.119,0,0,1,3.264-1.137,1.412,1.412,0,0,0,.852-.073,3.962,3.962,0,0,0,1.2-.757c.912-.934,1.764-1.928,2.639-2.9.094-.1.184-.21.281-.31.255-.263.529-.3.73-.088a.466.466,0,0,1-.029.707q-.97,1.073-1.936,2.15c-.349.387-.686.784-1.048,1.156A3.5,3.5,0,0,1-4352.28-52Z",
    transform: "translate(-7.752)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M-4364.751-51.5l-.744.557L-4372-57.47l-.122.044a7.949,7.949,0,0,0,.3,1.515,8.2,8.2,0,0,0,.978,1.787c.683.929,1.444,1.8,2.183,2.689a4.267,4.267,0,0,0,.718.73,1.674,1.674,0,0,0,.746.283c.311.041.526.142.531.469s-.217.442-.524.471a1.521,1.521,0,0,1-1.318-.464c-.689-.743-1.35-1.512-2.011-2.28-.4-.461-.777-.939-1.159-1.413A6.1,6.1,0,0,1-4373-57.064a4.221,4.221,0,0,1-.021-.944.714.714,0,0,1,1.081-.561,1.914,1.914,0,0,1,.523.371q3.278,3.264,6.544,6.539C-4364.841-51.625-4364.814-51.581-4364.751-51.5Z",
    transform: "translate(0 -2.592)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M-4256.828,75.114l.589-.7,1.837,2.158c.42.493.833.991,1.258,1.479a1.248,1.248,0,0,0,1.984.051,1.243,1.243,0,0,0-.052-1.985c-1.121-.974-2.253-1.934-3.38-2.9-.115-.1-.228-.2-.379-.33l.6-.716c.9.766,1.764,1.5,2.629,2.245.405.346.814.688,1.211,1.044a2.178,2.178,0,0,1,.069,3.268,2.161,2.161,0,0,1-3.315.014c-1.008-1.142-1.977-2.317-2.962-3.478A1.135,1.135,0,0,1-4256.828,75.114Z",
    transform: "translate(-107.364 -123.456)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M-4228.325-38.7a2.975,2.975,0,0,1,.292-.439q1.78-1.8,3.572-3.583c.284-.284.548-.307.761-.087s.186.467-.106.76c-1.183,1.185-2.361,2.375-3.561,3.542a.848.848,0,0,1-.595.182C-4228.081-38.335-4228.187-38.551-4228.325-38.7Z",
    transform: "translate(-133.695 -17.101)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M-4204.1-23.33a2.523,2.523,0,0,1-.265.411q-1.808,1.821-3.626,3.632a.471.471,0,0,1-.7.071c-.221-.185-.2-.481.044-.732,1.208-1.212,2.414-2.426,3.639-3.619a.753.753,0,0,1,.569-.147C-4204.316-23.7-4204.223-23.481-4204.1-23.33Z",
    transform: "translate(-151.69 -34.873)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.092550cf.svg";
export { ForwardRef as ReactComponent };